import type { IModuleWrapperProps } from '@audacy-clients/core/components/ModuleRenderer/types';
import { useTrackModuleView } from 'web/src/hooks/useTrackModuleView';

const ModuleInViewWrapper = ({
  children,
  isTopLevel,
  module,
}: IModuleWrapperProps): JSX.Element => {
  const moduleRef = useTrackModuleView({
    moduleId: module.id,
    contentId: module.config.contentId,
  });

  if (!isTopLevel) {
    return <>{children}</>;
  }

  // Don't fade, it causes heavy jank
  return <div ref={moduleRef}>{children}</div>;
};

export default ModuleInViewWrapper;
